module.exports = __webpack_public_path__ + "static/media/footer-bg-1-2.70d6fd54.svg";